import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { getProgrammeBySlug, programmes } from '../data/programmes';
import './ProgrammeDetail.css';

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--amber)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const ArrowLeft = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
  </svg>
);

export default function ProgrammeDetail() {
  const { slug } = useParams();
  const prog = getProgrammeBySlug(slug);

  if (!prog) return <Navigate to="/what-we-do" replace />;

  const otherProgs = programmes.filter(p => p.id !== prog.id).slice(0, 3);

  return (
    <main>
      <section
        className="prog-hero"
        style={{ backgroundImage: `url('${prog.heroImage || prog.image}')` }}
        aria-label={`${prog.name} hero`}
      >
        <div className="prog-hero-overlay" />
        <div className="container prog-hero-content">
          <Link to="/what-we-do" className="prog-back-link">
            <ArrowLeft /> All Programmes
          </Link>
          <h1>{prog.name}</h1>
          <p>{prog.shortDescription}</p>
        </div>
      </section>

      <section className="section" aria-label="Programme detail">
        <div className="container">
          <div className="prog-detail-grid">
            <div className="prog-detail-main">
              {prog.fullDescription.split('\n\n').map((para, i) => (
                <p key={i}>{para.trim()}</p>
              ))}
            </div>

            <aside className="prog-detail-sidebar">
              <div className="prog-sidebar-card prog-sidebar-includes">
                <h3>What This Programme Includes</h3>
                <ul>
                  {prog.whatIsIncluded.map((item, i) => (
                    <li key={i}><CheckIcon /><span>{item}</span></li>
                  ))}
                </ul>
              </div>

              <div className="prog-sidebar-card prog-sidebar-impact">
                <div className="prog-impact-label">Impact</div>
                <p className="prog-impact-text">{prog.impactStatement}</p>
              </div>

              <div className="prog-sidebar-card prog-sidebar-donate">
                <h3>Support This Programme</h3>
                <p className="donate-nudge-text">{prog.donationNudge}</p>
                <Link to="/donate" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                  Donate Now
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* Other programmes */}
      <section className="section other-progs-section" aria-labelledby="other-progs-heading">
        <div className="container">
          <div className="section-title">
            <span className="eyebrow">Other Programmes</span>
            <h2 id="other-progs-heading">More Ways We Help</h2>
            <div className="divider divider-center" />
          </div>
          <div className="grid-3">
            {otherProgs.map(p => (
              <div className="card" key={p.id}>
                <img src={p.image} alt={p.name} className="card-img" loading="lazy" />
                <div className="card-body">
                  <h3 style={{ fontSize: '1.05rem', color: 'var(--green)' }}>{p.name}</h3>
                  <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)', margin: '0.5rem 0 1rem' }}>{p.shortDescription}</p>
                  <Link to={`/what-we-do/${p.slug}`} className="btn btn-outline-green btn-sm">Learn More</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
